import * as moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';

export function getStringDate(date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export class MathUtil {
  static formatCurrency(value: number) {
    return new Intl.NumberFormat('es-GT', {
      style: 'currency',
      currency: 'GTQ',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };
}

export class ArrayUtil {
  static order(rows: any[], isYear) {
    if (rows.length <= 1) {
      return rows;
    } else {
      rows.sort((a, b) => {
        if (isYear) {
          return a.year - b.year;
        } else {
          const dateA = new Date(a.month);
          const dateB = new Date(b.month);
          return dateA.getTime() - dateB.getTime();
        }
      });
      return rows;
    }
  }
}

export function getLongDate(stringDate: string): number {
  return DateUtil.parseDateToMilliseconds(stringDate);
}

export function downloadFile(text: string, type: string, name: string) {
  const fileBytes = Uint8Array.from(atob(text), c => c.charCodeAt(0));
  // Crea un Blob con los bytes del PDF
  var fileBlob = null;
  const downloadLink = document.createElement('a');
  if (type == 'pdf') {
    fileBlob = new Blob([fileBytes], { type: 'application/pdf' });
    downloadLink.download = name + '.pdf';
  } else {
    fileBlob = new Blob([fileBytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    downloadLink.download = name + '.xlsx';
  }
  const pdfUrl = URL.createObjectURL(fileBlob);
  downloadLink.href = pdfUrl;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export class DateUtil {
  // Define a static method to parse date and convert to milliseconds
  static parseDateToMilliseconds(dateString: string, timezone: string = 'America/Guatemala'): number {
    // Parse the date string in the given format and timezone
    const date = moment.tz(dateString, 'YYYY-MM-DD', timezone);
    // Convert the date to milliseconds
    return date.valueOf();
  }

  static parseToMilliDateTime(dateString: string, timezone: string = 'America/Guatemala'): number {
    // Parse the date string in the given format and timezone
    const date = moment.tz(dateString, 'YYYY-MM-DDTHH:mm', timezone);
    // Convert the date to milliseconds
    return date.valueOf();
  }

  static getActualDate() {
    return moment().tz("America/Guatemala").format('YYYY-MM-DDTHH:mm');
  }

  static daysInMonth(month, year) {
    return new Date(parseInt(year), parseInt(month) + 1, 0).getDate();
  }

  static formatTimestamp(timestamp: number, inSeconds: boolean = false): string {
    // Si el timestamp está en segundos, lo convertimos a milisegundos
    const date = new Date(inSeconds ? timestamp * 1000 : timestamp);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Los meses empiezan en 0
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  static formatTimestampFromString(timestampStr: string, inSeconds: boolean = false): string {
    const timestamp = Number(timestampStr); // Convertimos string a number
    if (isNaN(timestamp)) {
        throw new Error("El valor recibido no es un número válido");
    }

    const date = new Date(inSeconds ? timestamp * 1000 : timestamp);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}
}

export class ColorUtil {
  static getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  static shadeColor(color, percent) {
    let f = parseInt(color.slice(1), 16),
      t = percent < 0 ? 0 : 255,
      p = percent < 0 ? percent * -1 : percent,
      R = f >> 16,
      G = (f >> 8) & 0x00FF,
      B = f & 0x0000FF;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  }
}

export class PaginationUtil {

  static reset(elements) {
    elements.startElement = 0;
    elements.pageIndex = 0;
    elements.lastElement = elements.pageSize;
    elements.filter = elements.total.slice(elements.startElement, elements.lastElement);
    elements.lastElement = elements.filter.length;
    return elements;
  }
}

export class CopyUtil {
  static copy(copyText) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}

export class PermsUtil {
  static hasPerm(perms, searched) {
    if (perms) {
      for (let i = 0; i < perms.length; i++) {
        const tempPermission = perms[i];
        if (tempPermission['roleId'] == searched) {
          return true;
        }
      }
    }
    return false;
  }
}